import React from "react";
import Banner from "../components/Banner";
import Header from "../components/headers/Header";
import ServicesTab from "../components/services/ServicesTab";
import Contact from "../components/contact/Contact";
import ProductsTab from "../components/products/ProductsTab";
import About from "../components/about/About";

const HomePage = () => {
  return (
    <div className="page">
      <Header />
      <About />
      <ServicesTab />
      <ProductsTab />
      <Contact />
      {/* <Banner /> */}
    </div>
  );
};

export default HomePage;
